var React   = require("react");
var request = require('superagent');

var ModalDialog = require('patternity/lib/modal_dialog');

var ViewRewardDetails = React.createClass({
  getDefaultProps : function(){
    return {
      name : "",
      id : "",
      path : ""
    };
  },
  propTypes : {
    name : React.PropTypes.string.isRequired,
    id : React.PropTypes.string.isRequired,
    path : React.PropTypes.string.isRequired
  },
  getInitialState : function(){
    return {
      isModalOpen : false,
      content : ""
    };
  },
  render : function() {
    return (
      <div className="view-reward-details" key={this.props.id}>
        <a href={this.props.path} onClick={this._showRewardDetails} data-remote={true}>
          {this.props.name}
        </a>
        {this._rewardDetails()}
      </div>
    );
  },
  _showRewardDetails : function(event){
    event.preventDefault();
    this._getRewardDetails();
  },
  _rewardDetails : function(){
    return (
      <ModalDialog id={"reward-detail-" + this.props.id}  key={"modal-" + this.props.id} size="large" isModalOpen={this.state.isModalOpen}>
        <ModalDialog.Body>
          <div dangerouslySetInnerHTML={{__html:this.state.content}}></div>
        </ModalDialog.Body>
      </ModalDialog>
    );
  },
  _getRewardDetails : function(){
    request.get(this.props.path)
      .set('Accept', "text/html; charset=utf-8")
      .set('X-Requested-With', 'XMLHttpRequest')
      .set('Content-Type', "text/html; charset=utf-8")
      .end(this._handleResponse);
  },
  _handleResponse : function(error, response){
    this.setState({
      isModalOpen : true,
      content : response.text
    }, this._afterResponseIsSet);
  },
  _afterResponseIsSet : function(){
    this._runSelect2();
    this._addCloseModalOnRedeem();
  },
  _runSelect2 : function(){
    $('select').select2();
  },
  _addCloseModalOnRedeem : function(){
    var that = this;
    var thisModalButton = "#reward-detail-" + this.props.id + " #redeem-this-reward";

    $(thisModalButton).one("click", function(event){
      that.setState({
        isModalOpen : false
      });
    });
  }
});

module.exports = ViewRewardDetails;



// WEBPACK FOOTER //
// ./src/advocate/rewards/_view_reward_details.jsx